// The sentences the two approval screens have to say IDENTICALLY (#1693).
//
// Screen 2 shows the code and screen 3 reads it, and the one thing the issue
// requires of both is that the member is told the two phones must be together.
// A sentence written twice is a sentence that drifts: someone edits screen 3's
// wording, screen 2 keeps the old one, and the requirement is quietly half
// kept. So it is defined once here, the way `error-copy.js`, `promise-copy.js`
// and `reset-copy.js` already hold copy this directory shares, and
// `approval-copy.spec.js` pins that both screens render it.
//
// ⚠️ COPY SIGN-OFF IS OUTSTANDING. This is drafted the way #1652's stranded
// copy shipped: written here, flagged on #1667 for the product call, and not
// held for it. If the wording changes, it changes in one place.

/**
 * The out-of-band secret's whole constraint, in one sentence a member can act
 * on. Deliberately neutral about which phone the reader is holding, because
 * the same words appear on the phone showing the code and on the phone reading
 * it.
 */
export const TOGETHER_SENTENCE =
  'Both phones need to be in the same place for this: one shows the code, the other reads it.';

/**
 * The words on the scan surface itself — the viewfinder overlay the approving
 * phone draws over a transparent app while the camera is live (#1693).
 *
 * Here rather than in the host for the same reason as the sentence above: the
 * scan is offered from a modal today and could be offered from a page
 * tomorrow, and the words a member reads over a live camera should not depend
 * on which one they came through.
 */
export const SCAN_COPY = Object.freeze({
  /** Under the cutout. What to point the camera AT, not what the app is doing. */
  aim: 'Point this at the code on the other phone',
  /** The way out. The plugin draws no UI of its own, so this is the only one. */
  cancel: 'Stop scanning',
});
